import { useMemo } from 'react';
import { UIMatch, useMatches } from 'react-router-dom';
import { RouteHandleSidebar } from '@/types/route-handle-sidebar';

const matchHasSidebarConfig = (
  match: UIMatch<unknown, undefined | { sidebar?: RouteHandleSidebar }>,
): match is UIMatch<unknown, { sidebar: RouteHandleSidebar }> =>
  Boolean(match.handle?.sidebar);

export const useSidebarConfig = () => {
  const matches = useMatches() as UIMatch<
    unknown,
    undefined | { sidebar: RouteHandleSidebar }
  >[];

  return useMemo(() => {
    let config: RouteHandleSidebar = {};
    const array = matches.filter(matchHasSidebarConfig);
    if (array.length > 0) {
      config = array[0].handle.sidebar;
    }
    return config;
  }, [matches]);
};
